export default "/images/vendor/x-data-spreadsheet/sprite.svg?28a6df6fc2a815a964dd76805aa8a3e6";